const loadAsyncJS = require('./general/m_loadAsyncJS');

export function checkAdBlocker() {
  window.adblocker = true;
  loadAsyncJS(window.Groupon.ads.url);
}
